import { useAdmin } from '@tv2-cas/offspring/admin/AdminProvider';
import { QueryClientProvider } from '@tv2/lib-offspring/api/graphql/QueryClientProvider';
import React from 'react';

export default function QueryClientProviderWrapper({
  apiUrl,
  children,
}: {
  apiUrl: string;
  children: React.ReactNode;
}) {
  const { isAdmin } = useAdmin();
  return (
    <QueryClientProvider apiUrl={apiUrl} isAdmin={isAdmin}>
      {children}
    </QueryClientProvider>
  );
}
